module.exports = __webpack_public_path__ + "img/lcbz2.4dada95b.png";